import React, { useContext, useEffect } from "react"
import { Text, View } from "react-native"
import { useAppSelector } from "../store"
import { CustomActionSheet, CustomActionSheetRef } from "../utility/CustomActionSheet"
import { ThemedButton } from "../utility/input/buttons"
import SpecifyValues from "../specify-values"
import { textStyles } from "../style"
import { ThemeContext } from "../utility/context/ThemeContext"

const ValuesSelection = ({ setStepHandler, setNextEnabled, loading }) => {
  const theme = useContext(ThemeContext).theme
  const { textMain } = theme.colors

  const { user } = useAppSelector((state) => state.auth)
  
  const specifyValuesSheetRef = React.useRef<CustomActionSheetRef>(null)

  const hideSheet = () => {
    if (specifyValuesSheetRef.current) {
      specifyValuesSheetRef.current.hide()
    }
  }
  const openSheet = () => {
    if (specifyValuesSheetRef.current) {
      specifyValuesSheetRef.current.show()
    }
  }

  useEffect(() => {
    setNextEnabled(!user.needsValueSelection)
  }, [user.needsValueSelection])

  return <View style={{flex: 1,gap: 20}}>
    <View style={{flex: 1, gap: 20}}>
      <Text style={[textStyles.body, {color: textMain}]}>
        In order to provide you with the most value,{' '}
        we need to know what values you prioritize and hold as a consumer.
      </Text>
      <Text style={[textStyles.body, {color: textMain}]}>
        Throughout your Impact Banking experience, you will be able to{' '}
        modify your selected values and preferences with a quick form.
      </Text>
      <Text style={[textStyles.body, {color: textMain}]}>
        To select your values, please click the <Text style={{fontWeight: "bold"}}>Open Values Selection Sheet</Text> button below.
      </Text>
    </View>

    <ThemedButton
      text="Open Values Selection Sheet"
      onPress={openSheet}
      variant="primary"
      textStyle={{marginHorizontal: 16}}
    />
    <CustomActionSheet
      ref={specifyValuesSheetRef}
      name="onboarding-specify-values"
    >
      <SpecifyValues
        hideSheet={hideSheet}
      />
    </CustomActionSheet>
  </View>
}

export default ValuesSelection